import { Link } from "react-router-dom";
import { HelpCircle, Phone } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { SectionHeading } from "@/components/Primitives";
import { FAQS } from "@/data/site";

export default function FAQ() {
  return (
    <div>
      <section className="pt-36 pb-16 bg-brand-green">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading light overline="FAQ" title="Answers to common questions"
            subtitle="Everything you need to know about our services, safety, and guarantees." />
        </div>
      </section>
      <section className="py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-4">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}
                className="bg-white rounded-2xl border border-black/5 px-6 shadow-sm">
                <AccordionTrigger className="text-left font-heading font-semibold text-brand-green hover:no-underline py-5">
                  <span className="flex items-center gap-3"><HelpCircle className="h-5 w-5 text-brand-gold shrink-0" />{f.q}</span>
                </AccordionTrigger>
                <AccordionContent className="text-brand-muted leading-relaxed pb-5 pl-8">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <div className="mt-12 bg-white rounded-3xl p-8 border border-black/5 shadow-sm text-center">
            <h3 className="font-heading text-xl font-bold text-brand-green">Still have questions?</h3>
            <p className="text-brand-muted mt-2">Our friendly team is one call away.</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center mt-6">
              <a href="tel:16723775455"><Button className="rounded-full bg-brand-green text-white font-semibold hover:bg-brand-greenHover"><Phone className="h-4 w-4 mr-2" /> +1 (672) 377-5455</Button></a>
              <Link to="/contact"><Button variant="outline" className="rounded-full border-brand-green/20 text-brand-green font-semibold">Contact Us</Button></Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
